export default __webpack_public_path__ + "img/c1642bfb6b635accf817bffaffc675d2.svg";